module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Billing information"},"es":{"title":"Información de facturación"},"fr":{"title":"Coordonnées de facturation"},"it":{"title":"Informazioni di fatturazione"},"pt":{"title":"Informações de faturação"},"pl":{"title":"Dane do faktury"}}')
  delete Component.options._Ctor
}
